<template>
  <div
    class="self_nav-bar van-nav-bar van-nav-bar--fixed van-hairline--bottom"
    style="z-index: 100;"
    :class=" color ? 'self_bg_color' : transparent ? '' : '' "
    :style="{ backgroundColor: color ? color : '#FFF', color: color ? '#fff' : '#5f5f5f' }"
  >
    <div class="van-nav-bar__left">
      <van-icon
        size="20"
        @click="backFn"
        :color="color?'#fff':'#5f5f5f'"
        v-if="back"
        slot="left"
        name="arrow-left"
      />
      <!-- <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" @click="backFn()"></i> -->
    </div>
    <div class="van-nav-bar__title van-ellipsis">
      <van-dropdown-menu
        :class=" color ? 'self_bg_color' : transparent ? '' : '' "
        :active-color="themeColor"
        style="height: 46px;"
        :style="{ backgroundColor: color ? color : 'transparent'}"
      >
        <van-dropdown-item
          @change="selectChange(value)"
          v-model="value"
          :options="options"
        />
      </van-dropdown-menu>
    </div>
    <div class="van-nav-bar__right"></div>
  </div>
</template>

<script>
export default {
  name: 'headNavx',
  data () {
    return {
      value: 0 // 父組件傳入到子組件的值, 不允許在子組件內修改, 所以需要定義一個 value 替換 value_
    }
  },
  methods: {
    backFn () {
      this.$router.back();
    },
    islogin () {
      this.$emit('rightClick');
    }
  },
  mounted () {
    // 設置頭部標題
    this.value = this.value_
  },
  props: ['back', 'rightText', 'color', 'options', 'value_', 'selectChange']
};
</script>
<style scoped>
.van-dropdown-menu__title {
  color: #fff !important;
}

[class*="van-hairline"]:after {
  border-width: 0 !important;
}
</style>
<style lang="less" scoped>
.self_nav-bar {
  & /deep/ .van-dropdown-menu__bar {
    background-color: transparent !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/headNavx.vue